import BaseController from '../../BaseController';

export class InfusionInterruptionBaseController extends BaseController {
  protected static routeInStack = {
    infusionInterruptSolution: false,
    infusionPartialVolume: false,
  }
}